import { render, staticRenderFns } from "./newOneNews.vue?vue&type=template&id=64c34cd5&scoped=true&"
import script from "./newOneNews.vue?vue&type=script&lang=js&"
export * from "./newOneNews.vue?vue&type=script&lang=js&"
import style0 from "./newOneNews.vue?vue&type=style&index=0&id=64c34cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c34cd5",
  null
  
)

export default component.exports